// extracted by mini-css-extract-plugin
export default {"dataPicker":"DatePicker_dataPicker__UWMGc","dataPickerSmall":"DatePicker_dataPickerSmall__jJrK3"};